module.exports = __webpack_public_path__ + "img/feed-alert-v2.bd20940d.svg";